module.exports = __webpack_public_path__ + "static/roll-d844783895cddb9ffb1e9a11e77ab160.gif";